export default "__VITE_ASSET__f8d26ac7__"